$(function () {
  var calculator = $('.calculator')
  var price_wrapper = calculator.find('.total-wrapper')
  var contact_button = calculator.next('a')
  var users = calculator.find('.users input:last')
  var plugins = calculator.find('.plugins .plugin')

  var calculate = function () {
    var total_users = Number(users.val())
    var show_contact_button = false
    var discount = false
    if (total_users < 20) {
      // do nothing
    } else if (total_users >= 20 && total_users < 50) {
      // 10% discount per plugin
      discount = true
    } else {
      show_contact_button = true
    }

    if (!show_contact_button) {
      price_wrapper.show()
      contact_button.removeClass('active')

      var plugins_sum = 0
      plugins.each(function () {
        if ($(this).find('input').prop('checked')) {
          plugins_sum += Number($(this).attr('data-price'))
        }
      })
      if (discount) {
        plugins_sum = plugins_sum - (plugins_sum * 10) / 100
      }
      total = total_users * plugins_sum

      calculator.find('.total').text(total + ' €')
    } else {
      // show contacts

      contact_button.addClass('active')
      price_wrapper.hide()
    }
  }

  $('.calculator .users input, .calculator .plugin input[type=checkbox]').on('change input', function () {
    calculate()
  })
  calculate()
})
